import * as React from "react";

const CloseIcon: React.FC<React.HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="m6.463 6.463 9.075 9.074M15.537 6.464l-9.074 9.074" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export { CloseIcon }